export default __webpack_public_path__ + "locales/lv/PaymentsEnterprise.json?hash=13f998f67cc1531ec436cfdd18ec1169";